import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {  faUserSecret, faUser, faUnlockAlt, faMapMarkerAlt, faEyeSlash, faEye,
          faBars, faKey, faLock, faSignOutAlt, faUserLock, faInfoCircle, faTasks, faAddressCard } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vuelidate from 'vuelidate'

import moment from 'moment'
require('moment/src/locale/pt-br');
import VuejsDialog from 'vuejs-dialog';
import * as GmapVue from 'gmap-vue'
import VueGeolocation from 'vue-browser-geolocation';

import IdleVue from "idle-vue";

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';


import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const toastOptions = {
    // You can set your default options here
};


Vue.use(Toast, toastOptions);

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyDID06e0FNCYVy13BgeVSVZmrYjiTYju6I',
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.use(VueGeolocation);

const eventsHub = new Vue()
 
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000
})

Vue.use(require('vue-moment'), {moment})
Vue.use(Vuelidate)

library.add(faUserSecret)
library.add(faUser)
library.add(faUnlockAlt)
library.add(faBars)
library.add(faKey)
library.add(faLock)
library.add(faSignOutAlt)
library.add(faUserLock)
library.add(faInfoCircle)
library.add(faMapMarkerAlt)
library.add(faTasks)
library.add(faEyeSlash)
library.add(faEye)
library.add(faAddressCard)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import './assets/css/app.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  created () {  
    /*
      this.$moment.locale('ptBR'); 
      this.$forceUpdate();

      console.log(this.$moment.locale());
      */
  }
}).$mount('#app')
